import styled from '@emotion/styled';

export default styled('div')`
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  overflow: hidden;
  word-break: break-word;
  width: 215px;
`;
